import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'request-error',
  templateUrl: './request-error.component.html',
  styleUrls: ['./request-error.component.sass']
})
export class RequestErrorComponent implements OnInit {

  constructor() { }

  @Input() public errors: string[];
  @Input() public notList: boolean

  ngOnInit() {
    
  }
}
